import axios from 'axios'
import { Notification, Loading } from 'element-ui'

// axios默认配置
axios.defaults.timeout = 30000   // 超时时间
axios.defaults.baseURL = (window.server || {}).apihost;
axios.defaults.loading = true;
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
console.log(axios.defaults.baseURL)
// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(config => {
  //config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  var token = localStorage.getItem("token");
  if (token)
  {
    config.headers.Authorization = token
  }
  if (config.loading)
    showLoading()
  return config
},
  error => {
    hideLoading();
    return Promise.reject(error.response);
  });

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
  response => {
    hideLoading();
    var data = response.data;
    if (data && data._suc)
    {
      Notification.success({
        title: '成功',
        duration: 2800,
        message: data._suc
      });
    }
    return Promise.resolve(data);
  },
  error => {
    hideLoading();
    var errormsg = "访问异常";
    if (!error.response && error.message)
    {
      console.error('本地错误:', error);
      return Promise.reject(error);
    }
    if (error.response.status != null && error.response.status != 200)
    {
      var json = null
      if (error.response.data.error)
      {
        errormsg = error.response.data.error;
      } else
      {
        errormsg = JSON.stringify(error.response.data);
      }
      if (errormsg == undefined || errormsg == '')
        errormsg = "Http error: " + error.response.statusText;
    }
    Notification.error({
      title: '失败',
      duration: 4000,
      message: errormsg
    });
    // 返回接口返回的错误信息
    return Promise.reject(error.response);
  });


let loadingRequestCount = 0;
let loadingInstance = null;
const showLoading = () => {
  if (loadingRequestCount === 0)
  {
    loadingInstance = Loading.service({ body: true, target: 'main' });
  }
  loadingRequestCount++
}
const hideLoading = () => {

  if (loadingRequestCount <= 0) return
  loadingRequestCount--
  if (loadingRequestCount === 0 && loadingInstance)
  {
    //vue.$nextTick(() => {//以服务的方式调用的 Loading 需要异步关闭
    loadingInstance.close();
    // });
  }
}


export default axios;



// WEBPACK FOOTER //
// ./src/axios/index.js